'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

// =============================================================================
// ELEVATION (Settings)
// =============================================================================
var _require = require('../variables.json'),
    $elevationMap = _require.$elevationMap;

var elevation = exports.elevation = function elevation(n) {
  return $elevationMap[Number(n) - 1];
};
//# sourceMappingURL=elevation.js.map